import styled from "styled-components";

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BenefitsList = styled.ul`
  padding-left: 16px;
  li {
    display: list-item;
    line-height: 1.5;
    list-style-position: outside;
    p {
      display: inline !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ImportantInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.ui.background.inset};
`;

export const ImportantInfoList = styled(BenefitsList)`
  li {
    p {
      font-size: 13px;
    }
  }
`;

export const DeclarationList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 16px;
  > li {
    display: flex;
    gap: 8px;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  gap: 8px;
`;

export const SignatureContainer = styled.div`
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.ui.background.inset};
  border-radius: 8px;
`;

export const ButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
`;
